export function setAppliedMode(mode) {
  document.documentElement.setAttribute("data-theme", mode);
}
